import { apiAxiosCMS } from 'services/api';
import { MenuItemLocationProps } from 'types/MenuItemLocationProps';

interface respProps {
	isSuccess: boolean;
	data: null | MenuItemLocationProps;
}

export async function addNewItem(
	dataform: MenuItemLocationProps,
	handleNotify: any
) {
	const resp: respProps = { isSuccess: false, data: null };
	const payload = {
		name: dataform.name
	};
	await apiAxiosCMS
		.post('menu-items-location', payload)
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res.data;
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.data = null;
			handleNotify(error.message || 'Erro ao salvar item de menu', 'error');
		});

	return resp;
}

interface RespEditProps {
	isSuccess: boolean;
	data: null | MenuItemLocationProps;
}

export async function editItem(
	dataform: MenuItemLocationProps,
	handleNotify: any
) {
	const resp: RespEditProps = { isSuccess: false, data: null };
	const payload = {
		...dataform,
		name: dataform.name
	};
	await apiAxiosCMS
		.patch(`menu-items-location/${dataform.id}`, payload)
		.then((res) => {
			resp.isSuccess = true;
			resp.data = res.data;
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.data = null;
			handleNotify(error.message || 'Erro ao editar o item de menu', 'error');
		});

	return resp;
}
